export default function (initialDataInteractor) {
  return initialDataInteractor.data.workspaces.filter(w => !w.is_archived);
}